import React from "react";
import { ProgressBar, Step } from "react-step-progress-bar";
import "react-step-progress-bar/styles.css";

const Stepper = ({ title, steps, activeStep }) => {
	const stepPercentage = (activeStep / (steps.length - 1)) * 100;

	return (
		<div
			className="steps-container d-flex flex-column justify-content-center pb-5 px-3"
		>
			{title && (
				<h1 className="d-none d-md-block text-center mb-5 font-weight-bold">
					{title}
				</h1>
			)}

			<ProgressBar
				className="steps"
				percent={stepPercentage}
				filledBackground="var(--color-state-success)"
			>
				{steps.map((label, index) => (
					<Step key={index}>
						{({ accomplished }) => (
							<div
								className={`step ${
									activeStep === index ? "step-active" : ""
								} ${
									accomplished ? "step-done" : "step-inactive"
								}`}
							>
								<span className="d-inline-flex justify-content-center align-items-center">
									{activeStep > index ? "\u2713" : index + 1}
								</span>
							</div>
						)}
					</Step>
				))}
			</ProgressBar>
		</div>
	);
};

export default Stepper;
